var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAbsentreport = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.475,
    height: 17.495,
    viewBox: "0 0 17.475 17.495",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-absenteeism-2077657",
    transform: "translate(-70.088 0.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M83.383,179.911a.273.273,0,0,0,.347-.171l.044-.124a.273.273,0,0,0-.513-.186q-.025.067-.046.137a.273.273,0,0,0,.169.344Z",
    transform: "translate(-12.702 -174.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M98.792,143.739a.273.273,0,0,0,.369-.116l.061-.117a.273.273,0,1,0-.481-.259l-.066.126h0a.273.273,0,0,0,.116.367Z",
    transform: "translate(-27.666 -139.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M119.451,110.87a.273.273,0,0,0,.381-.06l.078-.105h0a.273.273,0,0,0-.436-.329l-.085.115A.273.273,0,0,0,119.451,110.87Z",
    transform: "translate(-47.714 -107.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8459",
    "data-name": "Path 8459",
    d: "M242.805,18.063a.272.272,0,0,0,.1-.019l.124-.046a.273.273,0,1,0-.191-.512l-.137.05h0a.273.273,0,0,0,.1.527Z",
    transform: "translate(-167.057 -17.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M434.918,16.948l.124.053a.273.273,0,0,0,.2-.509l-.137-.049a.273.273,0,1,0-.189.512Z",
    transform: "translate(-353.254 -16.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M471.381,33.095l.116.064a.274.274,0,1,0,.273-.475l-.123-.068a.273.273,0,0,0-.261.481Z",
    transform: "translate(-388.634 -32.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M397.652,5.666l.128.027h0a.281.281,0,1,0,.12-.546l-.137-.03h0a.273.273,0,1,0-.111.535Z",
    transform: "translate(-317.13 -5.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M280.256,6.76a1.4,1.4,0,0,1,.579-.295.273.273,0,0,0-.24-.068l-.137.031a.273.273,0,0,0-.2.328Z",
    transform: "translate(-203.6 -6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M207.456,34.341a.274.274,0,0,0,.137-.034l.116-.064h0a.273.273,0,0,0-.259-.481l-.123.068a.273.273,0,0,0,.137.512Z",
    transform: "translate(-132.818 -33.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M581.114,142.359a.273.273,0,1,0,.483-.254l-.066-.124a.273.273,0,1,0-.479.261Z",
    transform: "translate(-494.978 -137.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M597.333,178.361c.015.041.03.083.044.124h0a.273.273,0,1,0,.516-.176l-.048-.137a.273.273,0,0,0-.513.187Z",
    transform: "translate(-510.771 -172.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M559.956,109.61a.274.274,0,0,0,.443-.322l-.085-.113h0a.273.273,0,0,0-.437.328Z",
    transform: "translate(-474.448 -106.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M533.891,79.74a.273.273,0,0,0,.39-.381l-.1-.1h0a.273.273,0,1,0-.385.386Z",
    transform: "translate(-449.149 -77.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M174.333,55.294a.274.274,0,0,0,.16-.056l.105-.079h0a.273.273,0,1,0-.324-.44l-.113.085h0a.273.273,0,0,0,.167.49Z",
    transform: "translate(-100.72 -53.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M145.035,80.37a.273.273,0,0,0,.2-.082l.093-.094a.273.273,0,1,0-.384-.382l-.1.1a.273.273,0,0,0,.2.464Z",
    transform: "translate(-72.342 -77.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M504.3,54.235l.105.079h0a.273.273,0,1,0,.335-.431l-.113-.086h0a.273.273,0,1,0-.326.438Z",
    transform: "translate(-420.556 -52.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M252.384,5.138c.235-.3.86-1.116.228-1.693a1.012,1.012,0,0,0-.788-.247.829.829,0,0,0-.6.344l-.722.986V1.478a.837.837,0,0,0-.844-.827A.853.853,0,0,0,249.3.73V.312a.844.844,0,0,0-1.688,0V.33a.852.852,0,0,0-.347-.074.837.837,0,0,0-.844.827v.683a.852.852,0,0,0-.273-.045.837.837,0,0,0-.844.827V4.609a4.134,4.134,0,0,0,.038,1.591l.244,1.341a3.277,3.277,0,0,0,.515,1.215,1.865,1.865,0,0,0,.145.163,1.077,1.077,0,0,1,.232.321l-.41,4.828a.273.273,0,0,0,.25.3h.023a.273.273,0,0,0,.273-.25l.422-4.965-.025-.063a1.609,1.609,0,0,0-.369-.546,1.427,1.427,0,0,1-.105-.117,2.781,2.781,0,0,1-.41-.982l-.253-1.355v-.02a3.608,3.608,0,0,1-.034-1.351l.007-.033V2.555a.3.3,0,1,1,.6,0V4.89a.273.273,0,0,0,.546,0l-.023-3.806h0a.3.3,0,0,1,.6,0v3.8a.273.273,0,0,0,.082.2.35.35,0,0,0,.238.079.273.273,0,0,0,.273-.273V.312a.3.3,0,0,1,.6,0V4.89a.273.273,0,0,0,.1.212.328.328,0,0,0,.466-.074.32.32,0,0,0,.037-.137V1.477a.3.3,0,1,1,.6,0V5c0,.313.175.41.25.427a.41.41,0,0,0,.457-.2l1.006-1.376a.3.3,0,0,1,.217-.117.472.472,0,0,1,.358.108c.137.126.2.328-.289.956h0a3.393,3.393,0,0,0-.683,1.639,5.041,5.041,0,0,1-.557,1.4,1.372,1.372,0,0,1-.448.556h0a1.13,1.13,0,0,1-.313.066h-.026a.273.273,0,0,0-.352.281l.41,5.313a.273.273,0,0,0,.273.253h.022a.273.273,0,0,0,.251-.294L250.138,9a1.938,1.938,0,0,0,.3-.076c.37-.127.67-.661.754-.819a5.558,5.558,0,0,0,.61-1.559h0a2.868,2.868,0,0,1,.582-1.4Z",
    transform: "translate(-169.691 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M443.422,205.546v-1.63a.716.716,0,0,0-.711-.717.7.7,0,0,0-.148.016v-.478a.716.716,0,0,0-.711-.717.7.7,0,0,0-.21.036.71.71,0,0,0-1.417.064v.253a.7.7,0,0,0-.212-.035.716.716,0,0,0-.711.717V205.3l-.434-.62a.7.7,0,0,0-.518-.309.819.819,0,0,0-.657.216c-.522.5-.022,1.172.167,1.424a2.3,2.3,0,0,1,.437,1.1,4.246,4.246,0,0,0,.425,1.161c.037.075.087.168.146.264h0a2.311,2.311,0,0,1,.371-.031,2.337,2.337,0,0,1,.3.022,1.824,1.824,0,0,1-.332-.494,3.769,3.769,0,0,1-.382-1.01,2.822,2.822,0,0,0-.538-1.334c-.4-.539-.284-.649-.229-.7h0a.285.285,0,0,1,.218-.068.164.164,0,0,1,.127.074l.77,1.092a.35.35,0,0,0,.661-.209v-2.82a.166.166,0,1,1,.332,0v2.731a.273.273,0,0,0,.273.273h.046a.273.273,0,0,0,.273-.273V202.12a.166.166,0,0,1,.332,0v3.665a.273.273,0,0,0,.273.273h.037a.273.273,0,0,0,.273-.273v-3.048a.165.165,0,0,1,.331,0l-.018,3.046h0a.273.273,0,1,0,.546,0v-1.868a.166.166,0,1,1,.332,0v1.659l.01.075a2.922,2.922,0,0,1-.025,1.068l-.188,1.1a2.221,2.221,0,0,1-.306.765,1.08,1.08,0,0,1-.076.089,1.335,1.335,0,0,0-.294.455l-.026.063.326,3.161a.273.273,0,0,0,.273.244h.029a.273.273,0,0,0,.243-.3l-.318-3.022a.807.807,0,0,1,.163-.229,1.644,1.644,0,0,0,.115-.137,2.743,2.743,0,0,0,.41-.994l.193-1.075a3.473,3.473,0,0,0,.027-1.3Z",
    transform: "translate(-355.907 -195.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M75.208,204.373a.7.7,0,0,0-.512.306l-.438.624v-2.25a.716.716,0,0,0-.711-.717.7.7,0,0,0-.212.035v-.253a.71.71,0,0,0-1.417-.064.7.7,0,0,0-.21-.036.716.716,0,0,0-.711.717v.477a.706.706,0,0,0-.147-.016.716.716,0,0,0-.713.718v1.639a3.474,3.474,0,0,0,.03,1.292l.194,1.072a2.73,2.73,0,0,0,.41,1,1.633,1.633,0,0,0,.115.137.806.806,0,0,1,.158.227l-.315,3.022a.273.273,0,0,0,.244.3H71a.273.273,0,0,0,.273-.244l.326-3.161-.026-.063a1.344,1.344,0,0,0-.294-.455,1,1,0,0,1-.076-.089,2.213,2.213,0,0,1-.309-.767l-.2-1.083v-.019h0a2.957,2.957,0,0,1-.026-1.06l.008-1.744a.166.166,0,1,1,.332,0v1.869a.273.273,0,0,0,.546,0l-.018-3.046a.165.165,0,1,1,.331,0v3.042a.273.273,0,0,0,.2.265.281.281,0,0,0,.386-.259v-3.666a.166.166,0,0,1,.332,0v3.665a.273.273,0,0,0,.221.273.3.3,0,0,0,.354-.167.3.3,0,0,0,.022-.106v-2.731a.166.166,0,0,1,.332,0v2.821a.351.351,0,0,0,.662.21l.776-1.1h0a.16.16,0,0,1,.123-.067.285.285,0,0,1,.218.068c.056.053.171.163-.229.7h0a2.821,2.821,0,0,0-.538,1.333,3.763,3.763,0,0,1-.376,1.01,1.874,1.874,0,0,1-.33.494,2.111,2.111,0,0,1,.674.011c.059-.1.108-.187.146-.264h0a4.234,4.234,0,0,0,.425-1.161,2.3,2.3,0,0,1,.437-1.1c.188-.254.683-.927.167-1.423a.819.819,0,0,0-.664-.216Z",
    transform: "translate(0 -195.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M150.52,446.25a1.775,1.775,0,1,0,1.255.52A1.775,1.775,0,0,0,150.52,446.25Zm0,3a1.229,1.229,0,1,1,.869-.36A1.23,1.23,0,0,1,150.52,449.254Z",
    transform: "translate(-76.202 -432.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M185.01,481.3a.273.273,0,0,0-.386,0l-.216.216-.217-.217h0a.273.273,0,1,0-.386.386l.217.217-.217.217h0a.273.273,0,1,0,.386.386l.217-.217.217.217h0a.273.273,0,0,0,.386-.386l-.217-.217.217-.217h0A.273.273,0,0,0,185.01,481.3Z",
    transform: "translate(-110.09 -466.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M439.28,446.25a1.775,1.775,0,1,0,1.255.52A1.775,1.775,0,0,0,439.28,446.25Zm0,3a1.229,1.229,0,1,1,.869-.36A1.229,1.229,0,0,1,439.28,449.254Z",
    transform: "translate(-355.949 -432.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M473.759,481.3a.273.273,0,0,0-.386,0l-.217.216-.216-.217h0a.273.273,0,0,0-.386.386l.216.217-.217.217h0a.273.273,0,1,0,.386.386l.217-.217.217.217h0a.273.273,0,0,0,.386-.386l-.217-.217.217-.217h0A.273.273,0,0,0,473.759,481.3Z",
    transform: "translate(-389.824 -466.716)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAbsentreport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/absentreport.387d72e9.svg";
export { ForwardRef as ReactComponent };